/**
 * Next.js Client Instrumentation – initialisiert das Kontora-Fehler-Reporting
 * vor Hydration. Sendet `window.error` und `unhandledrejection` an die BFF-
 * Route `/api/logs/ingest`, von der sie an die interne API weitergeleitet
 * werden (System-DB ErrorLog). Für Agenten lesbar über `/system/logs`.
 *
 * Initialisiert zusaetzlich das Web-Vitals-Tracking (LCP, FID, INP, CLS,
 * FCP, TTFB). Werte landen im LocalStorage unter `kontora_web_vitals_v1`
 * und koennen im Analytics-Dashboard eingesehen werden.
 */

import { registerErrorReporter, reportError } from './src/lib/errors/error-reporter.client';
import { initWebVitals } from './src/lib/onboarding/web-vitals';

try {
  registerErrorReporter();
} catch {
  // Initialisierung darf nichts werfen.
}

try {
  initWebVitals();
} catch {
  // Initialisierung darf nichts werfen.
}

export function onRouterTransitionStart(
  url: string,
  navigationType: 'push' | 'replace' | 'traverse',
): void {
  try {
    if (typeof performance !== 'undefined' && typeof performance.mark === 'function') {
      performance.mark(`kontora-nav-${navigationType}-${url}`);
    }
  } catch (err) {
    reportError({
      level: 'warn',
      source: 'frontend',
      context: 'instrumentation.onRouterTransitionStart',
      message: err instanceof Error ? err.message : String(err),
      stack: err instanceof Error ? err.stack : undefined,
      metadata: { url, navigationType },
    });
  }
}
